import { render, staticRenderFns } from "./EmailOnboardingMode.vue?vue&type=template&id=584f1520&scoped=true&"
import script from "./EmailOnboardingMode.vue?vue&type=script&lang=js&"
export * from "./EmailOnboardingMode.vue?vue&type=script&lang=js&"
import style0 from "./EmailOnboardingMode.vue?vue&type=style&index=0&id=584f1520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f1520",
  null
  
)

export default component.exports